import React from "react";
import { installConnectionWatch } from "./lib/connectivity";
import { ConnectionBanner } from "./components/ConnectionBanner";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// Register the push service worker (public/sw.js).
//
// This used to register a JANITOR whose job was to leave this origin with no
// service worker at all, after a stale Memso vite-plugin-pwa SW hijacked
// navigation on mail.3dbypixel.com and replayed a cached shell. That worker was
// evicted long ago and the janitor has done its job.
//
// The replacement is push-only: it defines NO fetch handler and writes no
// cache, so it cannot serve a stale page — which is the one property that made
// the original failure possible. Read the header of public/sw.js before
// changing it. Registration is best-effort; push must never block boot.
import { registerPushServiceWorker } from "./lib/push.js";
void registerPushServiceWorker();
import { App } from "./App.js";
// Tailwind base + components + utilities + safety-net layer.
import "./index.css";
// Side-effect: themeLoader brings in every theme's CSS variables and marks
// <html> with the saved (or default) theme on module load, before render.
import "./lib/themeLoader.js";
import { captureAppMarker } from "./lib/app-install.js";
import { AppErrorBoundary } from "./components/AppErrorBoundary.js";
import { reloadForChunk } from "./lib/chunkReload.js";

// Vite's own signal that a chunk it preloads failed (a redeploy while this
// page was open): reload once to the newest build (lib/chunkReload.ts).
window.addEventListener("vite:preloadError", (event) => {
  if (reloadForChunk()) event.preventDefault();
});

// Before anything renders or routes: the Android app puts its versionCode on
// the launch URL and only on the launch URL, so it has to be read before the
// router touches it.
captureAppMarker();
// Every request is watched for a lost connection (lib/connectivity.ts).
installConnectionWatch();

const rootElem = document.getElementById("root");
if (!rootElem) throw new Error("missing #root");
createRoot(rootElem).render(
  <React.StrictMode>
    {/* Outside the router, so a crash while routing is caught too. */}
    <AppErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ConnectionBanner />
    </AppErrorBoundary>
  </React.StrictMode>,
);
